import { Button, Card, Col, Row } from "antd";
import { grayheader, cardmargin } from "../../CSSReferences";
import { Component } from "react";
import { NewMandant } from "../typing/generalType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface LocalProps{
  //defince local porperies (maybe as tag parameter)
  // ONLY TYPES; NO VALUES
    id:string;
    url:string;
    client:NewMandant;
  // FUNCTIONS ALSO INCLUDE
  onSubmit: (data:NewMandant) => void;
  onConfigChange: (data:any, type:string) => void;
}



  // I can export a class or a const(function) of this. 
  // Minor differences

  const MyClientInputView = class ClientInputView extends Component<LocalProps, {}> 
  {

      
  ClientNameChange = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "name");
  };
  ClientDescChange = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "description");
  };
  CustomerNameChange = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "customername");
  };
  CustomerChangeMail = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "customermail");
  };
  CustomerChangePhone = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "customerphone");
  };
  CustomerChangeCompany = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "customercompany");
  };
  ContactTitleChange = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contacttitle");
  };
  ContactNameChange = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactname");
  };
  ContactLastNameChange = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactlastname");
  };
  ContactChangePhone = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactphone");
  };
  ContactChangeMail = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactmail");
  };
  ContactChangeStreet = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactstreet");
  };
  ContactChangePostCode = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactpostcode");
  };
  ContactChangeCity = (values: any) => {
    console.log(values.target.value);
    this.props.onConfigChange(values.target.value, "contactcity");
  };
  OnSubmitContact = () => {
    this.props.onSubmit(this.props.client);
  };
  OnSubmitCustomer = () => {
    this.props.onSubmit(this.props.client);
  };
  OnSubmit = () => {
    this.props.onSubmit(this.props.client);
  };
  render(){
    return (
      <div>
  <Row gutter={16}>
  <Col span={4}></Col>
      <Col span={16}>
        <Card title="Client Creator" style={cardmargin} hoverable styles={{ header: grayheader }}>
        <Row gutter={16}>
          <Col span={6}>
          <label>Client <FontAwesomeIcon icon={"campground"}/></label>
          </Col>
          <Col span={18}>    
          <input onChange={this.ClientNameChange}/>
          </Col>
          </Row>
          {/* <Row gutter={16}>
          <Col span={6}>
          <label>Tag <FontAwesomeIcon icon={"tag"}/></label>
          </Col>
          <Col span={18}>    
          <input value=" not finished" onChange={this.ClientDescChange}/>
          </Col>
          </Row> */}
          <Row gutter={16}>
        <Col span={16}></Col>
        <Col span={8}>
        {/* <Button type="primary" htmlType="submit" onClick={this.OnSubmit}>
          Submit
        </Button>     */}
        </Col>
        </Row>
      </Card>
      </Col>
      </Row>
      <Row gutter={16}>
      <Col span={12}>
      <Card title="Customer Information" style={cardmargin} hoverable styles={{ header: grayheader }}>
      <Row gutter={16}>
          <Col span={2}>
          <FontAwesomeIcon icon={"store"}/>
          </Col>
          <Col span={18}>    
          <input placeholder="Company Name" onChange={this.CustomerChangeCompany}/>
          </Col>
          </Row>
           <Row gutter={16}>
          <Col span={2}>
          <FontAwesomeIcon icon={"building"}/>
          </Col>
          <Col span={18}>    
          <input placeholder="Customer Name" onChange={this.CustomerNameChange}/>
          </Col>
          </Row>
          <Row gutter={16}>
          <Col span={2}>
          <FontAwesomeIcon icon={"phone"}/>
          </Col>
          <Col span={18}>    
          <input placeholder="Customer Phone" onChange={this.CustomerChangePhone}/>
          </Col>
          </Row>
          <Row gutter={16}>
          <Col span={2}>
          <FontAwesomeIcon icon={"envelope"}/>
          </Col>
          <Col span={18}>    
          <input placeholder="Customer Mail" onChange={this.CustomerChangeMail}/>
          </Col>
          </Row>
         
          <Row gutter={16}>
        <Col span={8}>
        
        {/* <Button type="primary" htmlType="submit" onClick={this.OnSubmitCustomer}>
          Submit
        </Button> */}
    
        </Col>
        </Row>
     
      </Card>
    </Col>
    <Col span={12}>
      <Card title="Contact Information" style={cardmargin} hoverable styles={{ header: grayheader }}>
          <Row gutter={12}>

        <Col span={2}>
        <FontAwesomeIcon icon={"user"}/>
          </Col>
            <Col span={4}>    
            <input placeholder="Title" style={{width: "50px"}} onChange={this.ContactTitleChange}/>
            </Col>
            <Col span={1}>    
            </Col>
            <Col span={12}> 
            <input placeholder="Name" style={{width: "115px"}} onChange={this.ContactNameChange}/>
            </Col>
          </Row>
          <Row gutter={12}>
          <Col span={2}>
            </Col>
            <Col span={6}> 
            <input placeholder="Lastname" style={{width: "150px"}}onChange={this.ContactLastNameChange}/>
            </Col>
          </Row>
          <Row gutter={16}>
        <Col span={2}>
        <FontAwesomeIcon icon={"phone-square"}/>
          </Col>
          <Col span={18}>   
          <input placeholder="Phone" onChange={this.ContactChangePhone}/>
          </Col>
          </Row>
          <Row gutter={16}>
          <Col span={2}>
          <FontAwesomeIcon icon={"envelope-square"}/>
          </Col>
          <Col span={8}>
          <input placeholder="Mail" onChange={this.ContactChangeMail}/> 
          </Col>
          </Row>
          <Row gutter={16}>
            <Col span={2}>
            <FontAwesomeIcon icon={"house-user"}/>
              </Col>
          <Col span={18}>   
              <input placeholder="Street" onChange={this.ContactChangeStreet}/>
              </Col>
              </Row>
          <Row gutter={16}>
          <Col span={2}>    
            </Col>
          <Col span={10}>   
              <input placeholder="PostCode" style={{width: "80px"}} onChange={this.ContactChangePostCode}/>
            </Col>
            <Col span={10}>   
              <input placeholder="City"  style={{width: "80px"}} onChange={this.ContactChangeCity}/> 
            </Col>
          </Row>
          <Row gutter={16}>
        <Col span={8}>
        </Col>
        <Col span={8}>
        <Button type="primary" htmlType="submit" onClick={this.OnSubmitContact}>
          Create Client
        </Button>
    
        </Col>
        </Row>
     
      </Card>
    </Col>
    </Row>
    </div>
    )
};
  }

export default MyClientInputView;